import React from 'react';
import { Check, Users } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function AudienceSection() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const audience = ['Personas que quieren aprender detailing automotriz desde cero', 'Personas que quieren empezar un negocio de servicios rentable', 'Personas que son apasionadas y quieren trabajar con autos', 'Personas que buscan generar ingresos extra los fines de semana'];
  return <section className="bg-[#0E1F3D] py-20 px-4" data-id="element-18">
      <div className="max-w-4xl mx-auto bg-[#132847] rounded-3xl shadow-xl overflow-hidden border border-[#1E3A5F]" data-id="element-19">
        <div className="bg-black p-8 text-center relative overflow-hidden" data-id="element-20">
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20" data-id="element-21"></div>
          <Users className="w-12 h-12 text-[#D4AF37] mx-auto mb-4 relative z-10" data-id="element-22" />
          <h2 className="text-3xl md:text-4xl font-black text-white uppercase relative z-10" data-id="element-23">
            ¿Para quién es el Método Detailing Pro?
          </h2>
        </div>

        <div className="p-8 md:p-12" data-id="element-24">
          <div className="space-y-6 mb-12" data-id="element-25">
            {audience.map((item, index) => <div key={index} className="flex items-center gap-4 bg-[#0A1628] p-4 rounded-xl border border-[#1E3A5F]" data-id="element-26">
                <div className="bg-green-900/50 p-2 rounded-full flex-shrink-0" data-id="element-27">
                  <Check className="w-6 h-6 text-green-400 font-bold" data-id="element-28" />
                </div>
                <p className="text-lg md:text-xl font-bold text-white" data-id="element-29">
                  {item}
                </p>
              </div>)}
          </div>

          <div className="text-center" data-id="element-30">
            <p className="text-gray-400 font-medium mb-6" data-id="element-31">
              Si te identificas con al menos uno de estos puntos, este programa
              es exactamente lo que necesitas.
            </p>
            <CTAButton text="SÍ, ESTO ES PARA MÍ" onClick={scrollToPricing} className="w-full md:w-auto md:min-w-[350px]" data-id="element-32" />
          </div>
        </div>
      </div>
    </section>;
}